import { render, staticRenderFns } from "./HerisOrdenesEdit.vue?vue&type=template&id=298c08a6&"
import script from "./HerisOrdenesEdit.vue?vue&type=script&lang=js&"
export * from "./HerisOrdenesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports